import React from "react"
import { useSelector } from "react-redux"
import { Card, CardBody, Col, Row, Spinner } from "reactstrap"

const MiniWidget = ({ icon, heading, subHeading, loading }) => {
  const mode = useSelector(s => s.Layout?.layoutMode)
  const colors = {
    cardBg: mode === "dark" ? "#252F40" : "#FFFFFF",
    text: mode === "dark" ? "#FFFFFF" : "#252F40",
    muted: mode === "dark" ? "#B9C0CA" : "#6B7280",
    iconBg: mode === "dark" ? "rgba(255,255,255,0.08)" : "#F1F1F1",
    iconFg: "#2990DF",
    up: "#58DB83",
    down: "#EF4444",
    badgeBg: mode === "dark" ? "rgba(88,219,131,0.12)" : "#E6F8EE",
  }
  return (
    <Card
      className="mini-stat mt-4"
      style={{
        background: colors.cardBg,
        borderRadius: 14,
        border: `1px solid ${mode === "dark" ? "#344356" : "#e5e7eb"}`,
        height: "calc(100% - 24px)",
      }}
    >
      <CardBody className="card-body px-3 py-4">
        {loading ? (
          <Spinner size="lg" color={mode === "dark" ? "light" : "primary"} />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            <div>
              <h6
                style={{
                  margin: 0,
                  fontSize: 14,
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                  color: colors.muted,
                  fontWeight: 600,
                }}
              >
                {heading}
              </h6>
            </div>

            {/* ROW 2: Total + Trend (left) | Round Icon (right) */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {/* Left: total + trend */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    fontSize: 16,
                    color: colors.text,
                    fontWeight: 700,
                  }}
                >
                  {subHeading}
                </h2>
              </div>

              {/* Right: round icon */}
              <div
                style={{
                  width: 48,
                  height: 48,
                  minWidth: 48,
                  minHeight: 48,
                  borderRadius: "50%",
                  background: colors.iconBg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {icon}
              </div>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default MiniWidget
